import { Column, Grid, Row, Sheet } from '@smwb/summer-ui'
import get from 'lodash/get'
import { useFormState } from 'react-final-form'
import style from './photoView.module.less'
import { useState } from 'react'
import { Text } from '@/components/ui/typography/text'
import { useParams } from 'react-router-dom'
import ImageMagnifier from './imageMagnifier/imageMagnifier'
import cs from 'classnames'
import { getTaskImageByName } from '@modules/missions/keaz/utils/step'

export interface PhotoUrl {
  original: string
  miniature: string
}

const altImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII='

export interface PhotoViewProps<T> {
  fieldName: keyof T
  subField?: string
  maxPhoto?: number
  title?: string
  compact?: boolean
}

export function PhotoView<T>({ fieldName, subField, title }: PhotoViewProps<T>) {
  const [viewOpenPhoto, setViewOpenPhoto] = useState<{ url: string; index: number } | undefined>(
    undefined
  )
  const { values, errors, touched } = useFormState<T>()
  const { missionId } = useParams()

  // костыль для типов со сложной структурой формы...
  const value =
    (get(values, `${fieldName.toString()}${subField ? '.' + subField : ''}`) as T[keyof T] &
      PhotoUrl[]) ?? ([] as T[keyof T] & PhotoUrl[])

  const isTouched = touched ? Object.values(touched).find((el) => el) : false

  const error = get(
    errors,
    `${fieldName.toString()}${subField ? '.' + subField : ''}`
  ) as T[keyof T]

  return (
    <>
      {title && <Text size='l'>{title}</Text>}
      {!!error && !!isTouched && (
        <h3 className={style.error}>
          {typeof error === 'object' ? JSON.stringify(error) : error.toString()}
        </h3>
      )}
      <Grid className={style.layout}>
        <Row spacing={2}>
          {value.map((el, i) => {
            const urlCreator = window.URL || window.webkitURL
            const imageUrl =
              typeof el.miniature === 'string'
                ? el.miniature
                : (el.miniature as unknown) instanceof Blob
                ? urlCreator.createObjectURL(el.miniature as unknown as Blob)
                : getTaskImageByName(missionId || '', el.original)
            return (
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
              <Column xs={2} key={el.original}>
                {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
                <img
                  src={imageUrl}
                  alt={altImage}
                  onClick={() => setViewOpenPhoto({ url: imageUrl, index: i })}
                />
              </Column>
            )
          })}
        </Row>
      </Grid>

      <Sheet
        size='80%'
        withSizeToggle={false}
        isOpen={!!viewOpenPhoto}
        onClose={() => setViewOpenPhoto(undefined)}
        variant='modal'
      >
        <div className={cs(style.imgView)}>
          <ImageMagnifier
            className={style.scale}
            src={viewOpenPhoto?.url}
            alt={altImage}
            magnifierRadius={100}
          />
        </div>
      </Sheet>
    </>
  )
}
